import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";

const SettingsContext = createContext(null);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    return {
      settings: {
        agency_name: "MAINGUY IMMOBILIER",
        address: "123 Rue de la Vigne, 33000 Bordeaux",
        phone: "05 56 00 00 00",
        email: "contact@mainguy-immobilier.fr",
        description: "Votre partenaire de confiance pour tous vos projets immobiliers",
        hours: "Lundi - Vendredi : 9h - 19h\nSamedi : 10h - 18h\nDimanche : Sur rendez-vous",
        facebook: "",
        instagram: "",
        linkedin: ""
      },
      loading: false
    };
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    agency_name: "MAINGUY IMMOBILIER",
    address: "123 Rue de la Vigne, 33000 Bordeaux",
    phone: "05 56 00 00 00",
    email: "contact@mainguy-immobilier.fr",
    description: "Votre partenaire de confiance pour tous vos projets immobiliers",
    hours: "Lundi - Vendredi : 9h - 19h\nSamedi : 10h - 18h\nDimanche : Sur rendez-vous",
    facebook: "",
    instagram: "",
    linkedin: ""
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error("Error fetching settings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const refreshSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error("Error refreshing settings:", error);
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsProvider;
